import React from 'react'

import Heading from './Heading.js';
import APIExamples from './APIExamples.js';
import Spealized from './Specialized.js';
import Overview from './Overview.js';
import Contacts from './Contacts.js';

import './Dashboard.scss'

function Dashboard() {
  return (
    <div className="container is-max-desktop">
      <Heading />
      <div className="honey-dashboard-spacer"></div>
      <APIExamples />
      <div className="honey-dashboard-spacer"></div>
      <Spealized />
      <div className="honey-dashboard-spacer"></div>
      <Overview />
      <div className="honey-dashboard-spacer"></div>
      <Contacts />
    </div>
  );
}

export default Dashboard;
